"use client";

import { createContext, useContext, useState } from "react";
import { create } from "zustand";
import { AiChatTempConfig } from "./interface";
interface Store {
  sceneTemplateList: AiChatTempConfig["sceneTemplateList"];
  slashCommandTemplateList: AiChatTempConfig["slashCommandTemplateList"];
}
const createStore = ({
  sceneTemplateList,
  slashCommandTemplateList
}: Store) => create<Store>(() => ({
  sceneTemplateList,
  slashCommandTemplateList
}));
const StoreContext = createContext<ReturnType<typeof createStore> | null>(null);
export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error("useStore must be used within a StoreProvider");
  }
  return context;
};
export const StoreProvider: React.FC<{
  children: React.ReactNode;
  sceneTemplateList: AiChatTempConfig["sceneTemplateList"];
  slashCommandTemplateList: AiChatTempConfig["slashCommandTemplateList"];
}> = ({
  sceneTemplateList,
  slashCommandTemplateList,
  children
}) => {
  const [store] = useState(() => createStore({
    sceneTemplateList,
    slashCommandTemplateList
  }));
  return <StoreContext.Provider value={store} data-sentry-element="unknown" data-sentry-component="StoreProvider" data-sentry-source-file="StoreProvider.tsx">{children}</StoreContext.Provider>;
};
interface GlobalStore {
  currentEntity: string;
  setCurrentEntity: (entity: string) => void;
  searchContent: string;
  setSearchContent: (content: string) => void;
  type: "submit" | "mention";
  setType: (type: "submit" | "mention") => void;
}

// 用于全局共享
export const useGlobalStore = create<GlobalStore>(set => ({
  currentEntity: "",
  type: "submit",
  setType: type => set({
    type
  }),
  setCurrentEntity: entity => set({
    currentEntity: entity
  }),
  searchContent: "",
  setSearchContent: content => set({
    searchContent: content
  })
}));